import {
  Insurance,
  InsuranceDetails
} from 'one-state-insurance';


import {
  FhirInsuranceDetails
} from 'one-state-fhirinsurance/src/fhirinsurance-details';

const formatdatestring=(dt:any)=>{
  const dateTime = new Date(dt);

  // Extract UTC components
  const year = dateTime.getFullYear();
  const month = dateTime.getMonth() + 1; // Month is zero-indexed, so add 1
  const day = dateTime.getDate();
  let hours = dateTime.getHours();
  let minutes: any = dateTime.getMinutes();
  let seconds = dateTime.getSeconds();

let ampm = hours >= 12 ? 'PM' : 'AM';

// Convert hours from 24-hour format to 12-hour format
hours = hours % 12;
hours = hours ? hours : 12; // the hour '0' should be '12' in 12-hour format

// Pad minutes with leading zeros if less than 10
minutes = minutes < 10 ? '0' + minutes : minutes;

// Construct the time string in 12-hour format
let timeString = hours + ':' + minutes + ' ' + ampm;
// Format the date and time as needed
const formattedDate = `${month.toString().padStart(2, '0')}-${day.toString().padStart(2, '0')}-${year}`;
const formattedTime = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
return [formattedDate,formattedTime,timeString]
}
export const TransformInsuranceDetails = (response: any, context: any,payload:any) => {

  //let responseInsurance:any = patientStubForInsuranceDetails();
  let insurancedata: Insurance[] = [];
  let insuranceresult: any = {
      insurancedata: insurancedata,
      error: undefined
  }
  const { log } = context;
  log.debug("one-epic", "TransformInsuranceDetails transformation entered", response);
  if (response && (response.status >= 400 || response.type == "error")) {
      insuranceresult.error = response;
  }
  if (response && response.length > 0) {
      response.map((record: any) => {
            record.map((ele: any) => {
                  let insurance: Insurance = {
                      planname: null,
                      groupnumber: null,
                      insurancedetails: undefined
                  };

                  let insurancelist: InsuranceDetails[] = [];
                  insurance.planname = ele?.payerName ? ele.payerName : "";
                  insurance.groupnumber = ele?.GroupNumber ? ele.GroupNumber : "";
                  let insobj: InsuranceDetails = {
                      effectivefromdate: ele?.policyEffectiveDate ? ele.policyEffectiveDate : "",
                      effectivetodate: ele?.policyExpirationDate ? ele.policyExpirationDate : "",
                      producttype: ele?.ProductType ? ele.ProductType : "",
                      coveragetype: ele?.CoverageType ? ele.CoverageType : ""
                  }
                  insurancelist.push(insobj);
                  insurance.insurancedetails = insurancelist;
                  insurancedata.push(insurance);
              });
            //   const apiResponse = record
            //     if(payload?.PatientID===apiResponse?.insuredPersonId){
            //       const insuranceData:Insurance = {
            //         personId: apiResponse?.personId,
            //         personPayerId: apiResponse?.personPayerId,
            //         payerId: apiResponse?.payerId,
            //         planName: apiResponse?.payerName,
            //         policyNumber: apiResponse?.policyNumber,
            //         insuredPersonId:apiResponse?.insuredPersonId,
            //         // defaultCob: apiResponse?.defaultCob,
            //         policyEffectiveDate: formatdatestring(apiResponse?.policyEffectiveDate)[0],
            //         policyExpirationDate: formatdatestring(apiResponse?.policyExpirationDate)[0],
            //         // insuredPersonId: apiResponse?.insuredPersonId,
            //         // relationship: apiResponse?.relationship,
            //         isPatientInsurance: apiResponse?.isPatientInsurance,
            //         isActive: apiResponse?.isActive===true?'Active':'Not Active',
            //         relationShip:apiResponse?.relationship===null?'Self':apiResponse?.relationship
            //         // isDeleted: apiResponse?.isDeleted,
            //         // isAvailable: apiResponse?.isAvailable,
            //         // isEmployerInsurance: apiResponse?.isEmployerInsurance
            //       };
            //       insurancedata.push(insuranceData)
            //     }
          
      })
  }
  insuranceresult.insurancedata = insurancedata;
  log.debug("one-epic", "TransformInsuranceDetails transformation Completed", insuranceresult);
  return insuranceresult;
}

export const TransformFHIRDetails = (response: any, context: any) => {
/**
* @param result contains the transformed response
*/


  let result: any = {
      fhircoverage: [],
      error: undefined
  }

  const { log } = context;
  if (response && (response.status >= 400 || response.type == "error")) {
      result.error = response;
  }

  if (response && response.length > 0) {
      const rs = response;
      let coveragearray: FhirInsuranceDetails[] = [];
      rs.forEach((ele: any) => {
          let coverageobj: FhirInsuranceDetails = {
              payor: "",
              subscriberid: "",
              startdate: "",
              enddate: "",
              status: ""
          }
          if (ele?.entry && ele.entry.length > 0) {
              ele.entry.forEach((identifierdata: any) => {
                  coverageobj.status = identifierdata?.status ? identifierdata.status : "";
                  coverageobj.subscriberid = identifierdata?.subscriberId ? identifierdata.subscriberId : "";
                  coverageobj.startdate = identifierdata?.period?.start ? identifierdata.period.start : "";
                  coverageobj.enddate = identifierdata?.period?.end ? identifierdata.period.end : "";
                  if(identifierdata?.payor) {
                      identifierdata.payor.forEach((payordata: any) => {
                          coverageobj.payor = payordata?.display ? payordata.display : "";
                      })
                  }
              })
          }
          coveragearray.push(coverageobj);
      });
      result.fhircoverage = coveragearray;
  }
  log.debug(
      "ccw-gadget,patientFHIR-epic",
      "patientFHIR-epic transforamtion response ", {
      result
  });

  return result;
}